import React from 'react'
import { trimOverLengthString } from './CellText'
import { TextWrap, TextWrapUnread } from '../../utils/common'

const UnreadText = props => {
  return (
    <div className="flex justify-between">
      {props.isUnread ? (
        <TextWrapUnread width={props.width}>
          {trimOverLengthString(props.text, props.width)}
        </TextWrapUnread>
      ) : (
        <TextWrap width={props.width}>
          {trimOverLengthString(props.text, props.width)}
        </TextWrap>
      )}

      {props.icon}
    </div>
  )
}

export default UnreadText
